import { Component } from '@angular/core';
import { HeaderComponent } from '../../../header/components/header/header.component';
import { RouterOutlet } from '@angular/router';
import { FooterComponent } from '../../../footer/footer.component';

@Component({
    selector: 'app-simple-layout',
    templateUrl: './simple-layout.component.html',
    styleUrls: ['./simple-layout.component.scss'],
    imports: [HeaderComponent, RouterOutlet, FooterComponent]
})
export class SimpleLayoutComponent {

    constructor() {
    }
}
